import React from 'react';

const CustomRadio = ({ label, isRadio, children, extraClass, extraCss }) => {
  return (
    <label
      className={`form-check-label ${extraClass ? extraClass : ''}`}
      style={extraCss ? extraCss : {}}
    >
      {children}
      {label}
      <span className={isRadio ? 'circle' : 'form-check-sign'}>
        <span className="check"></span>
      </span>
    </label>
  );
};

export default CustomRadio;
